export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div className="lg:col-span-1">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-primary-500 text-background-50">
                <i className="ri-vip-crown-fill text-xl leading-none" />
              </span>
              <span className="font-display text-2xl text-background-50">
                吃瓜<span className="text-primary-400">榜单</span>
              </span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-200/80">
              把吃瓜玩成一场全民投票。实时榜单、人气PK、离谱投票，全网网友共同票选，你的选择决定榜单走向。
            </p>
            <a
              href="mailto:hello@chigua-ranking.example.com"
              className="mt-5 inline-flex items-center gap-2 text-sm text-background-100 transition-colors hover:text-accent-300"
            >
              <i className="ri-mail-line text-base leading-none" />
              hello@chigua-ranking.example.com
            </a>
          </div>

          {/* Sections */}
          <nav aria-label="热门板块">
            <h4 className="font-display text-base text-background-50">热门板块</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200/80">
              <li><a href="#hotlist" className="transition-colors hover:text-accent-300">实时热榜</a></li>
              <li><a href="#pk" className="transition-colors hover:text-accent-300">人气PK</a></li>
              <li><a href="#absurd" className="transition-colors hover:text-accent-300">离谱投票</a></li>
              <li><a href="#news" className="transition-colors hover:text-accent-300">瓜点速递</a></li>
            </ul>
          </nav>

          <nav aria-label="关于我们">
            <h4 className="font-display text-base text-background-50">关于我们</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200/80">
              <li><a href="#about" className="transition-colors hover:text-accent-300">关于吃瓜榜单</a></li>
              <li><a href="#faq" className="transition-colors hover:text-accent-300">吃瓜问答</a></li>
              <li><a href="#news" className="transition-colors hover:text-accent-300">编辑精选</a></li>
              <li><a href="#top" className="transition-colors hover:text-accent-300">回到顶部</a></li>
            </ul>
          </nav>

          {/* note */}
          <div>
            <h4 className="font-display text-base text-background-50">参与投票</h4>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80">
              榜单由全网网友共同票选，仅供娱乐讨论。理性吃瓜、友善发言，让每一次投票都轻松又有意义。
            </p>
            <a
              href="#hotlist"
              className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-400"
            >
              <i className="ri-fire-fill text-base leading-none" />
              立即去投票
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200/10 pt-6 sm:flex-row">
          <p className="text-xs text-background-200/70">© {new Date().getFullYear()} 吃瓜榜单 · 网友票选人气PK平台。仅供娱乐，理性吃瓜。</p>
          <div className="flex items-center gap-4 text-xs text-background-200/70">
            <a href="mailto:hello@chigua-ranking.example.com" rel="nofollow" className="transition-colors hover:text-accent-300">商务合作</a>
            <a href="mailto:hello@chigua-ranking.example.com" rel="nofollow" className="transition-colors hover:text-accent-300">选题投稿</a>
          </div>
        </div>
      </div>
    </footer>
  );
}